export default {"src":"/_next/static/media/enterprise-ai.5168ac1a.svg","height":159,"width":159,"blurWidth":0,"blurHeight":0};